import TypeWrapper from "../../utils/TypeWrapper";

export const FOOTER_STYLING = {
  CPYRT_1: {
    marginBottom: "5px",
    fontFamily: "'Poppins', serif",
    color: TypeWrapper.COLORS.BLACK,
  },
  CPYRT_2: { fontSize: "18px", fontFamily: "'Poppins', serif" },
};

export const NAV_BAR_STYLING = {
  BOX_CNTNR: {
    width: 240,
    height: "90%",
    display: "flex",
    overflow: "hidden",
    flexDirection: "column",
  },
  SDE_MNU_BX: { display: "flex", flexDirection: "column" },
  LG_BX: { marginTop: -60, backgroundColor: TypeWrapper.COLORS.RED },
  LG_CNTNR: { width: 200, marginLeft: 20, marginTop: 0 },
};

export const NAV_ITEM_STYLING = {};

export const DASHBOARD_LAYOUTS_STYLING = {};
